__turbopack_context__.v({
  "buttonContainer": "StripeElementContainer-module__TrU-0a__buttonContainer",
  "collapsed": "StripeElementContainer-module__TrU-0a__collapsed",
  "separatorWrapper": "StripeElementContainer-module__TrU-0a__separatorWrapper",
});
